// Configure community members allowed in the Reality Tunnel dropdown.
// Edit this list to add/remove addresses. Labels are optional.
// Example: { label: 'zet.box', address: '0x1234...abcd' }
export const REALITY_TUNNEL_WHITELIST = [
  { label: '0xBilly.eth', address: '0xf9963dbe9438a5ecb62e5e7c2c081c3d12d48dd5' },
  { label: 'Zet.box', address: '0x25d5C9DbC1E12163B973261A08739927E4F72BA8' },

];

